import { makeAutoObservable, toJS } from 'mobx'
import { Attachment } from 'entities/Attachment/model/Attachment'
import { RequestAttachment } from 'entities/Attachment/model/RequestAttachment'

import { type IChatbotMessage } from './type'

export class ChatbotMessage {
  message = ''
  attachments: Attachment[] = []
  private _conversationType: IChatbotMessage['type'] = 'auto'

  constructor(item?: IChatbotMessage) {
    if (!!item) this.syncOrigin(item)

    makeAutoObservable(this)
  }

  get tabs() {
    return [
      {
        key: 'manual',
        name: 'Custom',
      },
      {
        key: 'auto',
        name: 'AI Generated',
      },
    ]
  }

  get conversationType() {
    return this._conversationType
  }

  get isAutoConvType() {
    return this._conversationType === 'auto'
  }

  setConversationType = (type: IChatbotMessage['type']) => {
    this._conversationType = type
  }

  sync(message: string, attachments: Attachment[]) {
    this.message = message
    this.attachments = attachments
  }

  syncOrigin(item?: IChatbotMessage | null) {
    this.message = item?.message ?? ''
    this.attachments =
      item?.media_url?.map((item) => new Attachment({ requestAttachment: item })) ?? []
    this._conversationType = item?.type ?? 'auto'
  }

  toJSON(): IChatbotMessage {
    return toJS({
      type: this._conversationType,
      message: this.isAutoConvType ? '' : this.message,
      media_url: this.attachments.map((attachment) => new RequestAttachment(attachment)),
    })
  }

  reset() {
    this.message = ''
    this.attachments = []
  }
}
